import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { useRouteParams } from '../../../hooks/useRouteParams';
import { useFpId } from '../../../../hooks/useFpId';
import { queryKeys } from '../../../../api/queryKeys';
import { queryKeys as actionStepsReportQueryKeys } from '../../../../../ActionStepsReport/api/queryKeys';
import { selectCurrentClient } from '../../../../../CommonSelectors/CommonAreaSelector';

export const RESET_ACTION_STEPS_MK = 'resetActionSteps';

interface ResetActionStepParams {
  goalId: string;
  clientId: number;
  fpId: string;
}

const resetActionStep = async ({ goalId, clientId, fpId }: ResetActionStepParams): Promise<null> =>
  authFetch(`/Consumer/UpdatePlanActionSteps/Reset`, {
    method: 'POST',
    ...httpBodyOptions({
      GoalId: goalId,
      clientId,
      fpId,
    }),
  });

interface MutationParams {
  isReport?: boolean;
  goalId?: string;
}

export const useResetActionStepMutation = ({
  isReport,
  goalId: paramsGoalId,
}: MutationParams = {}) => {
  const queryClient = useQueryClient();

  const { Id: clientId } = useSelector(selectCurrentClient);
  const { goalId: routeGoalId } = useRouteParams();
  const fpId = useFpId();

  const goalId = isReport ? paramsGoalId : routeGoalId;

  return useMutation(() => resetActionStep({ clientId, goalId, fpId }), {
    onSettled: async () => {
      const queryKey = isReport
        ? actionStepsReportQueryKeys.actionSteps(clientId, fpId)
        : queryKeys.financialPlan(clientId, fpId);

      await queryClient.invalidateQueries(queryKey);
    },

    mutationKey: RESET_ACTION_STEPS_MK,
  });
};
